import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { DownArrow, UpArrow } from '@helpers/icon-dictionary';
import { SORT_DIRECTION_TYPES } from '@helpers/constants';

import { updateSortProps, updateSortedStudentIds } from '@containers/upf-assign/upf-assign-actions';
import { sortEntitiesByIds } from '@containers/entities/helpers';
import SvgIcon from '@components/svg-icon/svg-icon';

import getTranslations from '../translations';

import { Root, HeaderLeft, SvgWrapper, HeaderRight, StudentCountText } from './styled';

const DEFAULT_SORT_STUDENT_COLUMN = 'lastName';

const StudentHeader = ({ i18n }) => {
  /**
   * STORE
   */
  const dispatch = useDispatch();
  const sortedStudentIds = useSelector(state => state.UPFAssignReducer.sortedStudentIds);
  const sortDirection = useSelector(state => state.UPFAssignReducer.sortDirection);
  const sortValue = useSelector(state => state.UPFAssignReducer.sortValue);
  const students = useSelector(state => state.entitiesReducer.students);

  const isSortedByASC = sortDirection === SORT_DIRECTION_TYPES.ASC;
  const icon = isSortedByASC ? DownArrow : UpArrow;

  /**
   * FUNCTIONS
   */
  const handleOnClick = () => {
    const updatedDirection = isSortedByASC ? SORT_DIRECTION_TYPES.DESC : SORT_DIRECTION_TYPES.ASC;
    const updatedStudentIds = sortEntitiesByIds({
      entities: students,
      ids: sortedStudentIds,
      direction: updatedDirection,
      sortKey: sortValue
    });
    dispatch(updateSortedStudentIds(updatedStudentIds));
    dispatch(updateSortProps(updatedDirection, DEFAULT_SORT_STUDENT_COLUMN));
  };

  /**
   * LOKALISE
   */
  const { STUDENTS_TEXT, CURRENTLY_ASSIGNED_TEXT } = getTranslations({ i18n });

  return (
    <Root>
      <HeaderLeft role="button" tabIndex="-1" onClick={handleOnClick} data-testid="sort-student-list">
        <SvgWrapper>
          <SvgIcon icon={icon} />
        </SvgWrapper>
        <StudentCountText>{`${STUDENTS_TEXT} (${sortedStudentIds.length})`}</StudentCountText>
      </HeaderLeft>
      <HeaderRight>
        <div>{CURRENTLY_ASSIGNED_TEXT}</div>
      </HeaderRight>
    </Root>
  );
};

StudentHeader.propTypes = {
  i18n: PropTypes.object
};

export default StudentHeader;
